module.exports = __webpack_public_path__ + "img/logo_face_color.9f8f95af.svg";